import { shouldPolyfill } from '@formatjs/intl-getcanonicallocales/should-polyfill'

export default async function polyfill (): Promise<void> {
  // This platform already supports Intl.getCanonicalLocales
  if (shouldPolyfill()) {
    await import('@formatjs/intl-getcanonicallocales/polyfill')
  }
}
